<template>
  <div class="animated fadeIn">
    <Forms ref="frmSearch"
           title="PESQUISA DE AUTORIZAÇÕES"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Search="onClickSearch"
           v-on:Clear="onClearSearch">
      <div class="form-group row">
        <div class="col-md-3">
          <label for="cbxInsure">Situação:</label>
          <div class="input-group">
            <b-form-select v-model="searchForm.situacao.value" :options="searchForm.situacao.options" >
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                <optgroup label="FLUXO DE APROVAÇÃO">
                  <option :value="0">AGUARDANDO APROVAÇÃO RESPONSÁVEL REGIONAL</option>
                  <option :value="1">AGUARDANDO APROVAÇÃO CONTROLADORIA</option>
                  <option :value="2">AGUARDANDO APROVAÇÃO DIRETORIA</option>
                  <option :value="3">APROVADO</option>
                </optgroup>
                <optgroup label="REPROVAÇÃO">
                  <option :value="-1">REPROVADO RESPONSÁVEL REGIONAL</option>
                  <option :value="-2">REPROVADO CONTROLADORIA</option>
                  <option :value="-3">REPROVADO DIRETORIA</option>
                </optgroup>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="cbxInsure">Obra:</label>
          <autocomplete-z ref="obraRHTypeahead"
                          placeholder="Digite o nome da Obra"
                          iconClass="fas fa-hard-hat"
                          :serializer="(obra) => obra.referencia"
                          :debounceLength="2"
                          :formField="searchForm.obraID"
                          v-on:search="onSearchObra"
                          v-on:changeCode="onChangeCodeObra"/>
        </div>
        <div class="col-md-3">
          <label for="txtInsured"> Responsável:</label>
          <autocomplete-z ref="responsavelTypeahead"
                          placeholder="Digite o nome do Responsável"
                          iconClass="fas fa-users"
                          :serializer="(responsavel) => responsavel.codigo + ' - ' + responsavel.nome"
                          :debounceLength="3"
                          :formField="searchForm.responsavelID"
                          v-on:search="onSearchResponsavel"
                          v-on:changeCode="onChangeCodeResponsavel" />
        </div>
        <div class="col-md-3">
          <label for="cbxInsure">Regional:</label>
          <div class="input-group">
            <b-form-input type="text"
                          class="col-2 text-upper"
                          style="height: calc(2.09375rem + 2px);"
                          :placeholder="'Código'"
                          v-model="searchForm.secaoRH.value"
                          :size="searchForm.secaoRH.maxlength"
                          :state="searchForm.secaoRH.state"
                          @focus="onClearSection"
                          v-on:change="onChangeCodeSection"
            />&nbsp;
            <b-form-select v-model="searchForm.secaoRHID.value"
                           :options="searchForm.secaoRHID.options" >
              <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <template v-slot:FooterButtonLeft>
        <button type="button" class="btn btn-third btn-sm d-none" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew"><i class="fas fa-plus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.New}}</span></button>
      </template>
    </Forms>
    <Tables ref="tableGrid"
        :columns="['',
                  'Data Solicitação',
                  'Solicitante',
                  'Favorecido',
                  'Obra',
                  'Responsável',
                  'Regional',
                  'Equipe',
                  'Valor',
                  'Justificativa',
                  'Situação',
                  'Data Situação',
                  'Aprovador',
                  'Motivo']"
        :showReload="true"
        v-on:Load="onLoad"
        v-on:Reload="onLoadAuthorization">
      <tr v-for="(obj, index) in this.objList" v-bind:key="index">
        <TableColumn :IsCustom="true" class="text-center">
          <b-form-checkbox v-if="obj.situacao == null || obj.situacao >= 0 && obj.situacao <= 2" :id="`accept-${index}`" :name="`accept-${index}`" v-model="obj.checked" :value="true" unchecked-value="" size="sm"></b-form-checkbox>
          <b-form-checkbox v-else :id="`accept-${index}`" :name="`accept-${index}`" size="sm" disabled></b-form-checkbox>
        </TableColumn>
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataSolicitacao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.solicitante ? obj.solicitante.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.favorecido ? obj.favorecido.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.obraRH ? obj.obraRH.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.secaoRH ? obj.secaoRH.nome : ''" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.equipe ? 'SIM' : 'NÃO'" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="formatMoney(obj.valorSolicitado)" />
        <TableColumn :IsCustom="true" class="text-center">
          <span v-if="obj.justificativa" v-b-tooltip.hover :title="obj.justificativa"><i class="fas fa-comment-alt" style="font-size: 15px; color: #4d7da3;"></i></span>
          <span>&nbsp;</span>
        </TableColumn>
        <TableColumn :IsCustom="true" class="text-center">
            <b-badge v-if="obj.situacao == null || obj.situacao == 0" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO <br>RESPONSÁVEL REGIONAL</b-badge>
            <b-badge v-else-if="obj.situacao == 1" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> CONTROLADORIA</b-badge>
            <b-badge v-else-if="obj.situacao == 2" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> DIRETORIA</b-badge>
            <b-badge v-else-if="obj.situacao == 3" variant="success" pill style="padding: 6px 10px 6px 10px;">APROVADO</b-badge>
            <b-badge v-else-if="obj.situacao == -1" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO <br>RESPONSÁVEL REGIONAL</b-badge>
            <b-badge v-else-if="obj.situacao == -2" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO CONTROLADORIA</b-badge>
            <b-badge v-else-if="obj.situacao == -3" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO DIRETORIA</b-badge>
        </TableColumn>
        <TableColumn :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAprovacao" />
        <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.aprovador ? obj.aprovador.nome : ''" />
        <TableColumn :IsCustom="true" class="text-center">
          <span v-if="obj.motivoReprovacao" v-b-tooltip.hover :title="obj.motivoReprovacao"><i class="fas fa-comment-alt" style="font-size: 15px; color: #ff0000;"></i></span>
          <span>&nbsp;</span>
        </TableColumn>
      </tr>
      <template slot="footer">
        <div class="form-group row pt-3">
          <div class="col-md-12 pl-3">
            <button type="button" v-bind:disabled="this.objList != null && this.objList.length > 0 ? false : true" class="btn btn-third btn-sm" v-b-tooltip.hover :title="'Aprovar selecionados'" @click="onSetApproved"><i class="fas fa-check-circle"></i> Aprovar</button>&nbsp;
            <button type="button" v-bind:disabled="this.objList != null && this.objList.length > 0 ? false : true" class="btn btn-danger btn-sm" v-b-tooltip.hover :title="'Reprovar selecionados'" @click="onOpenDisapprovedModal"><i class="fas fa-times-circle"></i> Reprovar</button>
          </div>
        </div>
      </template>
    </Tables>
    <AuthorizationsModal ref="AuthorizationsModal" v-on:SetDisapproved="onSetDisapproved" />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../mixins/ExpenseMixin.js'
import TermType from '@/shared/utils/termtype.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import AuthorizationsModal from './authorizations-modal.vue'
import SearchForm from './search-form'
import AutocompleteZ from '@/components/forms/AutocompleteZ'

export default {
  name: 'AuthorizationExpenses',
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      data: null,
      searchForm: SearchForm,
      form: {
        accept: {
          value: null,
          required: false,
          state: null
        },
        selected: []
      },
      typeTerm: TermType
    }
  },
  components: {
    AuthorizationsModal,
    AutocompleteZ
  },
  computed: {
    filters: function () {
      return {
        obraRHID: this.searchForm.obraRHID.value,
        responsavelID: this.searchForm.responsavelID.value,
        secaoRHID: this.searchForm.secaoRHID.value,
        situacao: this.searchForm.situacao.value
      }
    }
  },
  methods: {
    onLoad () {
      this.onLoadAuthorization()
      this.onLoadAllSections()
    },
    onLoadAuthorization (filters) {
      loading.push()
      AcceptanceTermRepository.GetAllPaging(this.CompanySelected, this.typeTerm.MISCELLANEOUS_EXPENSES, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, filters)
        .then((response) => {
          this.onResultGrid(response)
          // TODO: Show success
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllAuthorization (filters) {
      loading.push()
      AcceptanceTermRepository.GetAlllWithApprovedPaging(this.CompanySelected, this.typeTerm.MISCELLANEOUS_EXPENSES, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, filters)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllSections () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then((response) => {
          if (response.data.code > 0) {
            this.searchForm.secaoRHID.options = this.onResultDropdown(response, null, f => f.codigo + ' - ' + f.nome)
          }
          loading.close()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSetApproved () {
      this.selected = this.objList.filter(e => e.checked).map(e => e.id)

      if (this.selected && this.selected.length > 0) {
        loading.push()
        const listApproved = {
          'listaAprovados': this.selected
        }
        AcceptanceTermRepository.SetApproved(listApproved)
          .then((response) => {
            // this.onResult(response)
            this.onLoadAuthorization()
            loading.close()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para aprovar', 'APROVAR AUTORIZAÇÃO')
      }
    },
    onOpenDisapprovedModal () {
      this.selected = this.objList.filter(e => e.checked).map(e => e.id)
      if (this.selected && this.selected.length > 0) {
        this.$refs.AuthorizationsModal.showModal()
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para reprová-lo', 'REPROVAR AUTORIZAÇÃO')
      }
    },
    onSetDisapproved (reason) {
      loading.push()
      this.selected = this.objList.filter(e => e.checked).map(e => e.id)
      if (this.selected && this.selected.length > 0) {
        let disapproved = []
        for (var i in this.selected) {
          disapproved.push({
            'id': this.selected[i],
            'motivo': reason
          })
        }
        AcceptanceTermRepository.SetDisapproved(disapproved)
          .then((response) => {
            // this.onResult(response)
            this.onLoadAuthorization()
            loading.close()
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onClearSection () {
      this.searchForm.secaoRH.value = ''
    },
    onChangeCodeSection (value) {
      var options = this.searchForm.secaoRHID.options
      this.searchForm.secaoRHID.value = ''
      for (var i in options) {
        var names = options[i].text.split('-')
        if (names[0].trim().toUpperCase() === value.toUpperCase()) {
          this.searchForm.secaoRHID.value = options[i].value
        }
      }
    },
    onClickSearch () {
      const filters = this.filters

      for (const prop in filters) {
        if (filters[prop] === null || filters[prop] === undefined || (typeof filters === 'string' && filters[prop].trim() === '')) {
          delete filters[prop]
        }
      }

      const queryFilter = Object.keys(filters).map(key => key + '=' + filters[key]).join('&')

      this.onLoadAuthorization(`&${queryFilter}`)
    },
    onClearSearch () {
      this.searchForm.situacao.value = null
      this.searchForm.obraRHID.value = null
      this.searchForm.responsavelID.value = null
      this.searchForm.secaoRH.value = null
      this.searchForm.secaoRHID.value = null
      this.onLoadAuthorization('')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/miscellaneous/authorizations/authorizations.vue